import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Alert, Button, Spinner, Form } from 'react-bootstrap';
import { authService } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, submitting, success, error
  const [message, setMessage] = useState('');
  const [validated, setValidated] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    
    // Validation du formulaire
    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    try {
      setStatus('submitting');
      const response = await authService.forgotPassword(email);
      setStatus('success');
      setMessage(response.msg || 'Instructions de réinitialisation envoyées à votre adresse email.');
    } catch (error) {
      setStatus('error');
      setMessage(error.msg || 'Erreur lors de l\'envoi des instructions de réinitialisation.');
    }
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">Réinitialisation du mot de passe</h4>
            </Card.Header>
            <Card.Body>
              {status === 'success' ? (
                <Alert variant="success">
                  <Alert.Heading>Email envoyé!</Alert.Heading>
                  <p>{message}</p>
                  <p>Veuillez vérifier votre boîte de réception et suivre les instructions pour réinitialiser votre mot de passe.</p>
                  <hr />
                  <p className="mb-0">
                    N'avez-vous pas reçu l'email? Vérifiez votre dossier de spam ou{' '}
                    <Button 
                      variant="link" 
                      className="p-0" 
                      onClick={() => {
                        setStatus('idle');
                        setMessage('');
                      }}
                    >
                      essayez à nouveau
                    </Button>.
                  </p>
                </Alert>
              ) : (
                <>
                  <p className="mb-4">
                    Entrez l'adresse email associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.
                  </p>
                  
                  {status === 'error' && (
                    <Alert variant="danger" className="mb-4">
                      {message}
                    </Alert>
                  )}
                  
                  <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Form.Group className="mb-4" controlId="email">
                      <Form.Label>Adresse email</Form.Label>
                      <Form.Control
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        placeholder="Entrez votre adresse email"
                      />
                      <Form.Control.Feedback type="invalid">
                        Veuillez entrer une adresse email valide.
                      </Form.Control.Feedback>
                    </Form.Group>
                    
                    <Button 
                      type="submit" 
                      variant="primary" 
                      disabled={status === 'submitting'}
                      className="w-100"
                    >
                      {status === 'submitting' ? (
                        <>
                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                          <span className="ms-2">Envoi en cours...</span>
                        </>
                      ) : 'Envoyer les instructions de réinitialisation'}
                    </Button>
                  </Form>
                </>
              )}
            </Card.Body>
            <Card.Footer className="text-center">
              <div className="d-flex justify-content-between">
                <Button variant="link" as={Link} to="/login" className="text-decoration-none">
                  Connexion
                </Button>
                <Button variant="link" as={Link} to="/register" className="text-decoration-none">
                  Inscription
                </Button>
                <Button variant="link" as={Link} to="/" className="text-decoration-none">
                  Accueil
                </Button>
              </div>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
